<div class="flex flex-col items-center justify-between h-full text-center">
  <div class="flex-1 flex flex-col justify-center">
    <h2 mat-dialog-title class="text-left">{{ "logout.title" | transloco }}</h2>

    <mat-dialog-content class="text-left">
      <p class="text-gray-700">{{ "logout.message" | transloco }}</p>
    </mat-dialog-content>
  </div>

  <mat-dialog-actions class="flex w-full gap-4">
    <button
      class="text-blue-600 hover:underline cursor-pointer"
      [mat-dialog-close]="false"
    >
      {{ "buttons.cancel" | transloco }}
    </button>
    <button mat-flat-button class="px-8 py-2" [mat-dialog-close]="true">
      {{ "buttons.logout" | transloco }}
    </button>
  </mat-dialog-actions>
</div>
